// extracted by mini-css-extract-plugin
module.exports = {"socialLink":"common-module--social-link--2UHC9","facebookLink":"common-module--facebook-link--2-zVC","instragramLink":"common-module--instragram-link--3n6x3"};